import { render } from "./template-incorporation-form-step-3.vue?vue&type=template&id=48123a3f&scoped=true"
import script from "./template-incorporation-form-step-3.vue?vue&type=script&lang=js"
export * from "./template-incorporation-form-step-3.vue?vue&type=script&lang=js"

import "./template-incorporation-form-step-3.vue?vue&type=style&index=0&id=48123a3f&scoped=true&lang=css"
import "./template-incorporation-form-step-3.vue?vue&type=style&index=1&id=48123a3f&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48123a3f"]])

export default __exports__